import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useEnefitConsultationFormSchema = () => {
  const { t } = useTranslation();

  return z.object({
    firstName: z.string(),
    lastName: z.string(),
    email: z.string(),
    phoneNumber: z.string(),
    agreement: z.literal(true, {
      errorMap: () => ({
        message: t(
          "electricityLeads.enefitConsultation.modal.form.fields.agreement.errors.required",
        ),
      }),
    }),
  });
};
